import * as d3 from "d3";
import { pointer } from 'd3-selection'
import { groups } from "d3-array";
// import { legend } from "@d3/color-legend"

const DEFAULT_OPTS = {
  width: 400,
  height: 300,
  margin: { top: 20, right: 30, bottom: 30, left: 50 },
  colors: d3.schemeTableau10,
  fillOpacity: 0.2,
};

// const mergeDatasets = (datasets) => {
//   return datasets.reduce((a, b) => a.concat(b.data), [])
// }

class CalendarChart {
  constructor(svg, data = [], opts = {}) {
    const { width, height, margin, colors, fillOpacity } = Object.assign(
      {},
      DEFAULT_OPTS,
      opts
    );

    this.svgElement = svg;
    this.svg = d3.select(svg);
    this.margin = margin;
    this.colorsRange = colors;
    this.fillOpacity = fillOpacity;

    this.setSize(width, height);

    this.setData(data)

    this.build();
  }

  fontSize = 10
  weekday = "sunday";
  formatMonth = d3.utcFormat("%b");
  formatDay = (i) => "SMTWTFS"[i];
  formatDate = (value) => {
    const dateStr = new Date(value).toUTCString()
    return dateStr.substr(0, dateStr.length - 13) // d3.utcFormat("%x");
  }
  formatClose = d3.format("$,.2f");
  formatValue = d3.format("+.2%");
  countDay = this.weekday === "sunday" ? (i) => i : (i) => (i + 6) % 7;
  timeWeek = this.weekday === "sunday" ? d3.utcSunday : d3.utcMonday;
  height = this.cellSize * (this.weekday === "weekday" ? 7 : 9);
  cellSize = 17;
  get years() {
    // return groups(this.data, (d) => d.date.getUTCFullYear()).reverse();
    return groups(this.data, (d) => {
      return d[0].getUTCFullYear()
    });
  }
  pathMonth(t) {
    const n = this.weekday === "weekday" ? 5 : 7;
    const d = Math.max(0, Math.min(n, this.countDay(t.getUTCDay())));
    const w = this.timeWeek.count(d3.utcYear(t), t);
    return `${
      d === 0
        ? `M${w * this.cellSize},0`
        : d === n
        ? `M${(w + 1) * this.cellSize},0`
        : `M${(w + 1) * this.cellSize},0V${d * this.cellSize}H${w *
            this.cellSize}`
    }V${n * this.cellSize}`;
  }

  colors() {
    return d3.scaleOrdinal(
      this.datasets.map((dataset) => dataset.id),
      this.colorsRange
    );
  }

  // buildLegend(datasets) {
  //   const size = 10;

  //   return this.legend
  //     .selectAll(".legend-item")
  //     .data(datasets)
  //     .join(
  //       (enter) => {
  //         const marginLeft = this.margin.left + 5;
  //         const marginTop = this.margin.top - 5;
  //         const marginBetween = 5;
  //         const textWidth = 15;
  //         const horizontal = true;
  //         let x, y;
  //         if (horizontal) {
  //           x = (d, i) =>
  //             marginLeft + i * (size + textWidth + marginBetween * 2);
  //           y = () => marginTop;
  //         } else {
  //           x = () => marginLeft;
  //           y = (d, i) => marginTop + i * (size + marginBetween);
  //         }

  //         enter
  //           .append("rect")
  //           .attr("class", "legend-item rect")
  //           .attr("x", x)
  //           .attr("y", y)
  //           .attr("width", size)
  //           .attr("height", size)
  //           .attr("fill", (d) => this.colors()(d.id));

  //         enter
  //           .append("text")
  //           .attr("class", "legend-item-label text label")
  //           .attr("x", (d, i) => x(d, i) + size + marginBetween)
  //           .attr("y", (d, i) => y(d, i) + size / 2)
  //           .attr("font-size", size)
  //           .text((d) => d.name)
  //           .attr("text-anchor", "left")
  //           .style("alignment-baseline", "middle");
  //         return enter;
  //       },
  //       (update) => {
  //         update.select("rect").attr("fill", (d) => this.colors()(d.id));

  //         update.select("text").text((d) => d.name);
  //       },
  //       (exit) => exit.remove()
  //     );
  // }

  build() {
    const year = this.svg
      .selectAll("g")
      .data(this.years)
      .join("g")
      .attr(
        "transform",
        // (d, i) => `translate(40.5, ${this.height * i + this.cellSize * 1.5})`
        (d, i) => `translate(40.5, ${i * (7 + 1) * this.cellSize + 1.5 * this.cellSize})`
      );

    // year label
    year
      .append("text")
      .attr("x", -5)
      .attr("y", -5)
      .attr('font-size', this.fontSize)
      .attr("font-weight", "bold")
      .attr("text-anchor", "end")
      .text(([key]) => key);

    // weekday label
    year
      .append("g")
      .attr("text-anchor", "end")
      .selectAll("text")
      .data(this.weekday === "weekday" ? d3.range(1, 6) : d3.range(7))
      .join("text")
      .attr("x", -5)
      .attr("y", (i) => (this.countDay(i) + 0.5) * this.cellSize)
      .attr("dy", "0.31em")
      .attr('font-size', this.fontSize)
      .text(this.formatDay);

    // day rect
    year
      .append("g")
      .selectAll("rect")
      .data(
        this.weekday === "weekday"
          ? ([, values]) =>
              values.filter((d) => ![0, 6].includes(d.date.getUTCDay()))
          : ([, values]) => values
      )
      .join("rect")
      .attr("width", this.cellSize - 1)
      .attr("height", this.cellSize - 1)
      // .attr("stroke-width", 4)
      // .attr("stroke", this.colorsRange[1])
      .attr(
        "x",
        (d) =>
          this.timeWeek.count(d3.utcYear(d[0]), d[0]) * this.cellSize + 0.5
      )
      .attr("y", (d) => this.countDay(d[0].getUTCDay()) * this.cellSize + 0.5)
      // .attr("fill", (d) => this.color(d.value))
      .attr("fill", this.colorsRange[0])
      .append("title")
      .text(
        (d) => `${this.formatDate(d[0])}
          ${d[1].map(z => `
            Rating: ${z.value.rating} ${z.value.failure ? ` (FAILURE)` : ''}
            Time: ${z.value.timeGroup.name}
            Type: ${z.value.type.name}
            Location: ${z.value.place.name} / ${z.value.location.name}
            Positions: ${z.value.positions.map(position => position.name).join(', ') }
          `)}
        `
      );

    const month = year
      .append("g")
      .selectAll("g")
      .data(([, values]) => {
        // return d3.utcMonths(
        //   d3.utcMonth(values[0][0]),
        //   values[values.length - 1][0]
        // )
        return d3.utcMonths(
          values[values.length - 1][0],
          values[0][0],
        )
      })
      .join("g");

    month
      .filter((d, i) => i)
      .append("path")
      .attr("fill", "none")
      .attr("stroke", "#fff")
      .attr("stroke-width", 3)
      .attr("d", (d) => this.pathMonth(d));

    month
      .append("text")
      .attr(
        "x",
        (d) => {
          return this.timeWeek.count(d3.utcYear(d), this.timeWeek.ceil(d)) *
            this.cellSize +
          2
        }
      )
      .attr("y", -5)
      .attr('font-size', this.fontSize)
      .text(this.formatMonth);

    // this.buildPaths(this.datasets);

    // this.buildLegend(this.datasets);

    return this.svg.node();
  }

  setSize(width, height) {
    this.width = width;
    this.height = height;

    this.svgElement.setAttribute("width", width);
    this.svgElement.setAttribute("height", height);
  }

  resize(width, height) {
    this.setSize(width, height);
    this.update(this.data);
  }

  setData(data) {
    this.data = groups(data, (d) => d.date)
  }

  update(data = undefined) {
    console.log(`[${this.constructor.name}]`, "chart.update", data);

    // update the class's data prop
    if (data) this.setData(data);

    // // update the X axis:
    // this.xAxisElement
    //   .transition()
    //   .duration(3000)
    //   .call(this.xAxis.bind(this));

    // // update the Y axis
    // this.yAxisElement
    //   .transition()
    //   .duration(3000)
    //   .call(this.yAxis.bind(this));

    // // update paths
    // this.buildPaths(datasets);

    // // update legend
    // this.buildLegend(datasets);
  }

  buildPaths(datasets) {
    const t = this.svg.transition().duration(750);

    this.paths
      .selectAll(".line")
      .data(datasets)
      .join(
        (enter) => {
          enter
            .append("path")
            .attr("class", "area")
            .attr("data-id", (d) => d.id)
            .attr("fill", (d) => this.colors()(d.id))
            .attr("fill-opacity", this.fillOpacity)
            .attr("stroke-width", 0)
            .datum((d) => d.data)
            .call((enter) => enter.transition(t).attr("d", this.area()));

          enter
            .append("path")
            .attr("class", "line")
            .attr("data-id", (d) => d.id)
            .attr("fill", "none")
            .attr("stroke", (d) => this.colors()(d.id))
            .attr("stroke-width", 1.5)
            .attr("stroke-linejoin", "round")
            .attr("stroke-linecap", "round")
            .datum((d) => d.data)
            .call((enter) => enter.transition(t).attr("d", this.line()));
        },
        (update) => {
          update
            .select(".line")
            .datum((d) => d.data)
            .call((update) => update.transition(t).attr("d", this.line()));

          update
            .select(".area")
            .datum((d) => d.data)
            .call((update) => update.transition(t).attr("d", this.area()));
        },
        (exit) =>
          exit.attr("fill", "brown").call((exit) =>
            exit
              .transition(t)
              .attr("y", 30)
              .remove()
          )
      );
  }

  mousemove = (bisector) => (e) =>  {
    // const { date, value } = bisector(d3.mouse(this.svg.node())[0]);
    const { date, value } = bisector(pointer(e)[0])

    const allData = this.datasets.map((ds) =>
      ds.data.find((d) => d.date.getTime() == date.getTime())
    );

    this.tooltip
      .attr("transform", `translate(${this.x()(date)},${this.y()(value)})`)
      .call(
        this.callout,
        `
        ${date.toLocaleString(undefined, {
          month: "short",
          day: "numeric",
          year: "numeric",
        })}
        ${allData
          .map(
            (item, i) =>
              `${this.datasets[i].name}: ${item.value.toLocaleString(
                undefined,
                {}
              )}`
          )
          .join("\n ")}
      `
      );
  }

  callout(g, value) {
    if (!value) return g.style("display", "none");

    g.style("display", null)
      .style("pointer-events", "none")
      .style("font", "10px sans-serif");

    const path = g
      .selectAll("path")
      .data([null])
      .join("path")
      .attr("fill", "white")
      .attr("stroke", "black");

    const text = g
      .selectAll("text")
      .data([null])
      .join("text")
      .call((text) =>
        text
          .selectAll("tspan")
          .data((value + "").split(/\n/))
          .join("tspan")
          .attr("x", 0)
          .attr("y", (_, i) => `${i * 1.1}em`)
          .style("font-weight", (_, i) => (i ? null : "bold"))
          .text((d) => d)
      );

    const { y, width: w, height: h } = text.node().getBBox();

    text.attr("transform", `translate(${-w / 2},${15 - y})`);
    path.attr(
      "d",
      `M${-w / 2 - 10},5H-5l5,-5l5,5H${w / 2 + 10}v${h + 20}h-${w + 20}z`
    );
  }

  bisect() {
    const datasetIndex = this.datasets.length - 1;
    const bisect = d3.bisector((d) => d.date).left;
    const data = this.datasets[datasetIndex].data;
    return (mx) => {
      const date = this.x().invert(mx);
      const index = bisect(data, date, 1);
      const a = data[index - 1];
      const b = data[index];
      if (b === undefined) return a;
      return date - a.date > b.date - date ? b : a;
    };
  }
}

export { CalendarChart };
